import { ASSETS } from "@/config/assets";

// Text logo: IL MAGO in black, TONY in green with brush underline flourish.
export function Logo({ className = "", size = "text-2xl", testId = "app-logo" }) {
  return (
    <span data-testid={testId} className={`font-display font-black tracking-tight ${size} ${className} select-none`}>
      <span className="brush-underline text-zinc-950">IL MAGO </span>
      <span className="text-green-500">TONY</span>
    </span>
  );
}

// Brand illustration slot (uploaded asset).
export function LogoMark({ className = "", testId = "logo-mark" }) {
  return (
    <img
      data-testid={testId}
      src={ASSETS.logo}
      alt="Il Mago Tony"
      className={className}
      draggable={false}
    />
  );
}
